import { render, staticRenderFns } from "./VendorIntroButton.vue?vue&type=template&id=45df653f&scoped=true&"
import script from "./VendorIntroButton.vue?vue&type=script&lang=js&"
export * from "./VendorIntroButton.vue?vue&type=script&lang=js&"
import style0 from "./VendorIntroButton.vue?vue&type=style&index=0&id=45df653f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df653f",
  null
  
)

export default component.exports